module.exports = __webpack_public_path__ + "img/Screenshot.c9934c71.webp";